module.exports = __webpack_public_path__ + "static/media/dsr_bg5.3dabfe85.png";